import React from 'react'
import OverlayRight, { StyledOverlayInnerWrapper } from '../Page/logix2020/OverlayRight'
import { StyledDataList } from '../DataList/dataList'
import AssetData from './AssetOverlay/AssetData'
import ActionSelect from './ActionSelect'

const AssetOverlay = (props) => {
  const {
    handleCloseOverlayRight, selectedRow, assetEntitiesAdministration
  } = props

  return (
    <OverlayRight visible={selectedRow} onClose={handleCloseOverlayRight}>
      <StyledOverlayInnerWrapper>
        <StyledDataList className="content">
          {assetEntitiesAdministration && <AssetData selectedRow={selectedRow} handleCloseOverlayRight={handleCloseOverlayRight} />}
          <ActionSelect selectedRow={selectedRow} />
        </StyledDataList>
      </StyledOverlayInnerWrapper>
    </OverlayRight>
  )
}

export default AssetOverlay
